export { default } from './withConfig'
